import tracking from '@finn-no/analytics';
import { ContextConfig } from '@finn-no/analytics/lib/types';
import { getEcEventData } from './event-data';
import { updateFinnGlobalVar } from './finn';
import { AdObj } from '../../shared/types/ast';
import { inscreen } from './lazy';

type BannerObjs = { [key: string]: AdObj };
type CreativeIds = { [key: string]: number };

const creativeIds: CreativeIds = {};
const bannerObjs: BannerObjs = {};
let hasHorseshoe = false;

export function logHorseshoe() {
    hasHorseshoe = true;
}

// should be exposed from @finn-no/analytics
type AnalyticsApi = {
    prepareContext: () => { context: ContextConfig };
};

export type AdditonalEventContext = {
    analyticsName: string;
    context: ContextConfig;
};

function track(
    type: string,
    tagId: string,
    element?: Element,
    adObj?: AdObj,
    additionalContext?: AdditonalEventContext,
) {
    const banner = adObj || bannerObjs[tagId];
    const creativeId = (adObj && adObj.creativeId) || creativeIds[tagId];

    tracking.getApi((api: AnalyticsApi) => {
        const context = api.prepareContext().context;
        if (context) {
            const vertical = context.vertical;
            const eventData = getEcEventData(
                tagId,
                element,
                vertical,
                creativeId,
                banner,
                hasHorseshoe,
            );

            const trackingConfig = {
                ecType: 'TRACKING',
                ecCategory: type,
                eventData,
            };

            if (additionalContext) {
                tracking.trackEvent({
                    ...trackingConfig,
                    ...additionalContext,
                });
            } else {
                // @ts-ignore analyticsName is missing
                tracking.trackEvent(trackingConfig);
            }
        }
    });
}

export function logInview(
    tagId: string,
    adObj: AdObj,
    additionalContext?: AdditonalEventContext,
) {
    logBannerObj(tagId, adObj);
    logCreativeId(tagId, adObj.creativeId);
    const element = document.getElementById(tagId);
    if (element) {
        track('inview', tagId, element, adObj, additionalContext);
        observeBanner(element);
    }
}

function logInscreen(element: Element) {
    const tagId = element.id;
    if (tagId) {
        track('inscreen', tagId, element);
    }
}

export function logClick(
    tagId: string,
    adObj?: AdObj,
    additionalContext?: AdditonalEventContext,
) {
    if (tagId) {
        track('click', tagId, undefined, adObj, additionalContext);
    }
}

export function logCreativeId(tagId: string, creativeId: number) {
    creativeIds[tagId] = creativeId;
    updateFinnGlobalVar(creativeIds);
}

function logBannerObj(tagId: string, adObj: AdObj) {
    bannerObjs[tagId] = adObj;
}

function observeBanner(ele: HTMLElement) {
    inscreen(ele, logInscreen, {
        timeout: 1000,
    });
}
